/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import Translation from '../translation/translation';
import {
  onOpenVehicleConfiguratorLayerClick,
  onOpenVehicleConfiguratorV2Click,
} from '../../../_views/configurator_buttons/configurator_buttons';
import CheckoutConfiguratorAnalytics from '../../../_modules/google_analytics/checkout_configurator';

function VehicleConfiguratorButton(props) {
  const { isVisibleV2, fromTyreSize } = props;
  return (
    <div
      className="configurator-alternative"
      onClick={(evt) => {
        evt.preventDefault();

        CheckoutConfiguratorAnalytics.customerClickedSearchByVehicleAction();

        if (isVisibleV2) {
          onOpenVehicleConfiguratorV2Click(fromTyreSize);
        } else {
          onOpenVehicleConfiguratorLayerClick();
        }
      }}
    >
      <div className="icon icon--vehicle"></div>
      <Translation
        translationKey={'configurator-button-search-by-vehicle'}
        className="configurator-vehicle"
        tagName="div"
      />
    </div>
  );
}

export default VehicleConfiguratorButton;
